import { Injectable } from '@angular/core';
import {
  ID,
  QueryEntity
} from '@datorama/akita';
import {
  ChartsDashboardCardStore,
  ChartsDashboardCardState
} from './charts-dashboard-card.store';
import { ICard } from './card.model';
import { IChartDashboard } from '../dashboard';

@Injectable({providedIn: 'root'})
export class ChartsDashboardCardQuery extends QueryEntity<ChartsDashboardCardState> {

  constructor(protected store: ChartsDashboardCardStore) {
    super(store);
  }

  public getCardsFromDashboard(dashboard: IChartDashboard<ID>): ICard<ID>[] {
    return dashboard.cards.map((id: ID) => this.getEntity(id));
  }
}
